import React from 'react'
import { HStack, SimpleGrid, Skeleton } from '@chakra-ui/react'

import SkeletonCard from '@/app/[locale]/_components/Skeleton/Card'
import { SkeletonText } from '@/components/ui/skeleton'

export function SkeletonProducts() {
  return (
    <>
      <SkeletonText mb={4} mt={12} noOfLines={1} />
      <SimpleGrid gap={{ base: 3, lg: 4 }} columns={{ base: 2, md: 3, lg: 4 }}>
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </SimpleGrid>
    </>
  )
}

export function SkeletonCategories() {
  return (
    <div>
      <HStack
        gap={'21px'}
        flexWrap={'wrap'}
        w={'full'}
        mt={6}
        display={{ base: 'none', lg: 'flex' }}
      >
        <Skeleton w={'141px'} height='56px' rounded={16} />
        {Array.from({ length: 15 }).map((_, idx) => {
          const widths = ['100px', '120px', '154px', '90px', '132px']
          const randomWidth = widths[Math.floor(Math.random() * widths.length)]

          return (
            <Skeleton key={idx} w={randomWidth} height='56px' rounded={16} />
          )
        })}
      </HStack>
      <HStack
        overflow={'scroll'}
        scrollbar={'hidden'}
        gap={'21px'}
        w={'full'}
        mt={6}
        display={{ base: 'flex', lg: 'none' }}
      >
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
        <Skeleton w={'56px'} height='56px' rounded={16} />
      </HStack>
    </div>
  )
}
